import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { datadogRum } from '@datadog/browser-rum';
import { useContext } from 'react';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useGetWhyBuyDataLoaded from './selectors/useGetWhyBuyDataLoaded';
import useWhyBuyData from './selectors/useWhyBuyData';
import useGetVaultWhyBuyNarrative from './useGetVaultWhyBuyNarrative';
import useIsInVaultExperiment from './useIsInVaultExperiment';
import useShowWhyBuyContent from './useShowWhyBuyContent';

export default function useWhyBuyDataEvent() {
  const { trackEvent } = useContext(AnalyticsContext);
  const isInVaultExperiment = useIsInVaultExperiment();
  const { isLoaded: hasWhyBuyLoaded } = useGetWhyBuyDataLoaded();
  const { type: whyBuyType, bulletPoints = [] } = useWhyBuyData();
  const showWhyBuyContent = useShowWhyBuyContent();
  const { narrativeVersion } = useGetVaultWhyBuyNarrative();
  const { narratives } = useGetVehicleDetails();

  useEffectOnce(
    () => {
      const eventData = {
        availableWhyBuyNarratives:
          narratives?.map(n => ({
            narrativeType: n?.narrativeType,
            narrativeVersion: n?.narrativeVersion
          })) ?? [],
        hasWhyBuy: showWhyBuyContent,
        narrativeVersion: narrativeVersion ?? 'ymmt',
        whyBuyCount: bulletPoints?.length ?? 0,
        whyBuyType
      };

      trackEvent('Why Buy Data', eventData);
      datadogRum.addAction('Why Buy Data', eventData);
    },
    [
      bulletPoints?.length,
      narratives,
      narrativeVersion,
      showWhyBuyContent,
      trackEvent,
      whyBuyType
    ],
    isInVaultExperiment && hasWhyBuyLoaded
  );
}
